import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect, useMemo } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { IndicadorObraForm, IndicadorObraSchema } from "../../../schemas/Obras_informacoesgerais/indicador_obra";
import { IndicadorDropDown } from "../../../../domain/models/indicador_dropdown";
import { IndicadorObra } from "../../../../domain/models/indicador_obra";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * IndicadorObraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  indicadores: IndicadorDropDown[];
  selectedIndicadorObra: IndicadorObra | null,
  onClose: () => void;
  onSubmit: (e: any) => void;
};

export const IndicadorObraModal = ({
  open,
  saving,
  loading,
  indicadores,
  selectedIndicadorObra,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<IndicadorObraForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(IndicadorObraSchema),
  });

  const filteredIndicadores = useMemo(() => {
    return indicadores.filter(x => x.canBeSelected);
  }, [
    indicadores,
  ]);

  const selectedIndicador = useMemo((): IndicadorDropDown | null => {
    if (selectedIndicadorObra === null || selectedIndicadorObra.idIndicador === null) return null;
    return indicadores.find(x => x.idIndicador === selectedIndicadorObra.idIndicador) ?? null;
  }, [
    indicadores,
    selectedIndicadorObra,
  ]);

  const editFlag = useMemo(() => {
    return selectedIndicadorObra !== null;
  }, [
    selectedIndicadorObra,
  ]);

  useEffect(() => {
    if (open) {
      if (selectedIndicadorObra && selectedIndicadorObra.idIndicador) {
        hookForm.setValue('idIndicadores', [selectedIndicadorObra.idIndicador]);
        hookForm.setValue('resultado', selectedIndicadorObra.resultado ?? '');
      } else {
        hookForm.reset({});
      }
    }
  }, [
    open,
    selectedIndicadorObra,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Especificidade Obra'}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          {
            !editFlag
              ? (
                <DefaultFormMultiAutocomplete
                  name='idIndicadores'
                  label='Indicador'
                  required={true}
                  getOptionKey={x => x.idIndicador}
                  getOptionLabel={x => x.descricao}
                  options={filteredIndicadores}
                  reactHookForm={hookForm}
                />
              )
              : (
                <DefaultAutocomplete
                  label='Indicador'
                  required={true}
                  getOptionKey={x => x.idIndicador}
                  getOptionLabel={x => x.descricao}
                  options={indicadores}
                  readOnly={true}
                  value={selectedIndicador}
                  onChange={() => { }}
                />
              )
          }
          {
            editFlag &&
            <DefaultFormInput
              name='resultado'
              label='Resultado'
              multiline={true}
              rows={10}
              reactHookForm={hookForm}
            />
          }
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}